/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZutrittskontrolleProtokollFilterOptionenDto } from '../../models/zutrittskontrolle-protokoll-filter-optionen-dto';

export interface GetZutrittskontrolleProtokollFilterOptionen$Json$Params {
}

export function getZutrittskontrolleProtokollFilterOptionen$Json(http: HttpClient, rootUrl: string, params?: GetZutrittskontrolleProtokollFilterOptionen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>> {
  const rb = new RequestBuilder(rootUrl, getZutrittskontrolleProtokollFilterOptionen$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>;
    })
  );
}

getZutrittskontrolleProtokollFilterOptionen$Json.PATH = '/v1/zutrittskontrolle/protokoll/filter-optionen';
